import { apiDELETE, apiGET, apiPOST, apiPUT } from '../utils/adapterFunctions'

export const createBankAccountV2 = async (data) => {
  return await apiPOST('/player/bank-accounts/v2', data)
}

export const updateDefaultBankAccount = async (id) => {
  return await apiPUT(`/player/bank-accounts/${id}/default`)
}

export const deleteBankAccount = async (id) => {
  return await apiDELETE(`/player/bank-accounts/${id}`)
}

export const getLivenessBankAccount = async (bankAccountId) => {
  const body = { bankAccountId }
  return await apiPOST('/player/bank-accounts/liveness', body)
}

export const getPlayerBankAccountStatus = async () => {
  return await apiGET('/player/bank-accounts', { hasNestedData: false })
}

export const requestLivenessProcess = async (reUseApproved) => {
  const options = reUseApproved ? { params: { reUseApproved } } : null;

  return await apiPOST('/player/bank-accounts/v2/liveness', null, null, options);
};